import React from "react";
const Login: React.FC = () => <div>Login Form (email/password, Google, etc.)</div>;
export default Login;
